import { ISession } from 'app/shared/model//session.model';
import { ISite } from 'app/shared/model//site.model';
import { IPricing } from 'app/shared/model//pricing.model';

export const enum EventTypes {
  NONE = '',
  TICKET_DELIVERY = 'ticketDelivery',
  COLLECTION_AT_SHOW = 'collectionAtShow'
}

export interface IEvent {
  id?: number;
  nameCht?: string;
  nameEng?: string;
  organizerCht?: string;
  organizerEng?: string;
  descriptionCht?: string;
  descriptionEng?: string;
  detailCht?: any;
  detailEng?: any;
  artistCht?: string;
  artistEng?: string;
  buyNotesCht?: any;
  buyNotesEng?: any;
  duration?: number;
  imageUrl?: string;
  seatingPlanUrl?: string;
  locationUrl?: string;
  maxTicketsPerOrder?: number;
  minCharge?: number;
  lowWaterMark?: number;
  enabled?: boolean;
  types?: string;
  sessions?: ISession[];
  site?: ISite;
  pricings?: IPricing[];
}

export const defaultValue: Readonly<IEvent> = {
  enabled: false
};

export interface IEventTypes {
  type?: any;
  minTicket?: number;
  deliveryChargeHk?: number;
  deliveryChargeMacau?: number;
  deliveryChargeOnsite?: number;
  sendQrCodeAttachment?: boolean;
  ignoreZoneSeat?: boolean;
  promotionCode?: string;
  promotionRuleCode?: string;
  merchantId?: string; // for new id
  paymentUrl?: string;
  hidePromoCheckbox?: boolean;
  labelOverrideAddress?: string;
}

export const defaultEventTypes: Readonly<IEventTypes> = {
  type: '',
  minTicket: 0,
  sendQrCodeAttachment: false,
  ignoreZoneSeat: false
};
